import { baseURL, $http } from './index'
import dayjs from 'dayjs'
import { useMessage } from '@/hooks'
import qs from 'qs'
// -------------快速调用办法-------------

// 构建取消请求的方法： CANCEL_TOKEN
// const CANCEL_TOKEN = axios.CancelToken
// const createCancelTokenBindKey = (requestKey) => {
//   return new CANCEL_TOKEN((cancelFun) => {
//     //强行中断请求要用到的，记录请求信息
//   })
// }

// post from 请求
function $postForm(url, data, { onUploadProgress = undefined } = {}) {
  return $http({
    url,
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    data,
    onUploadProgress: onUploadProgress
  })
}

function $postFile(url, data, { onUploadProgress = undefined, getFetchController = undefined } = {}) {
  let controller = null
  if (getFetchController) {
    controller = new AbortController()
    getFetchController(controller)
  }
  return $http({
    url,
    method: 'POST',
    headers: {
      'content-type': 'multipart/form-data'
    },
    data,
    onUploadProgress,
    signal: controller?.signal
  })
}

function $downloadFile(fileName = dayjs().format('YYYY-MM-DD HH:mm:ss'), url, params, method = 'GET') {
  let queryUrl = '', data = undefined
  if (method === 'GET') {
    queryUrl =  params ? url + '?' + qs.stringify(params) : url
  } else {
    data = params
  }
  return $http({
    url: queryUrl,
    method,
    responseType: 'blob', // 切记类型 blob
    data
  }).then((res) => {
    let blob = new Blob([res.data])
    let url = window.URL.createObjectURL(blob) // 创建 url 并指向 blob
    let a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
    window.URL.revokeObjectURL(url) // 释放该 url
  })
}

function $downloadPostFile(fileName = dayjs().format('YYYY-MM-DD HH:mm:ss'), url, params) {
  return $http({
    url,
    method: 'POST',
    responseType: 'blob',
    data: params
  }).then((res) => {
    let blob = new Blob([res.data])
    let url = window.URL.createObjectURL(blob)
    let a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
    window.URL.revokeObjectURL(url)
  })
}

// post json 请求
function $post(url, data) {
  let resultUrl = url
  if (data?.isMock) {
    resultUrl = 'https://apifoxmock.com/m1/5026365-0-default' + url
  }
  return $http({
    url: resultUrl,
    method: 'POST',
    headers: { 'content-type': 'application/json;charset=UTF-8' },
    data
  })
}

// get 请求
function $get(url, params) {
  let resultUrl = url
  if (params?.isMock) {
    resultUrl = 'https://apifoxmock.com/m1/5026365-0-default' + url
  }
  delete params?.isMock
  return $http({
    url: params ? resultUrl + '?' + qs.stringify(params) : url,
    method: 'get',
    headers: {}
  })
}
export function filterResponse(res, { catchDataReturn = false, showErrorMsg = true } = {}) {
  // 没有进行接口包装的情况
  if (res.data.isSuccess === undefined) {
    return res.data
  }
  // -
  let msg = ''
  if (res.status == 200) {
    if (res.data.isSuccess) {
      return res.data.data
    } else {
      msg = res.data.resultMsg
      if (showErrorMsg) { useMessage.message.error(msg) }
      if (catchDataReturn) {
        throw res.data
      } else {
        throw msg
      }
    }
  } else {
    if (res?.message) {
      msg = res?.message
    }
    if (res?.statusText) {
      msg = res?.statusText
    }
    if (res.response?.data?.resultMsg) {
      msg = res.response?.data?.resultMsg
    }

    if (showErrorMsg) { useMessage.message.error(msg) }
    throw msg
  }
}


// ---------export-----------
export { baseURL, $http, $post, $get, $postForm, $postFile, $downloadFile, $downloadPostFile }
